/**
 * @enum {string}
 */
var FormAction = /*#__PURE__*/function (FormAction) {
  FormAction["New"] = "new";
  FormAction["Edit"] = "edit";
  FormAction["Show"] = "show";
  return FormAction;
}(FormAction || {});
export default FormAction;